import produce from 'immer';

const INITIAL_STATE = {
  daysWeek: [],
  blockDates: [],
  counties: [],
  quotas: [],
  countiesProduts: [],
};

export default function unityRegistration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@unityregistration/UNITY_DAYSWEEK': {
        draft.daysWeek = action.payload.value;
        break;
      }

      case '@unityregistration/UNITY_BLOCKDATES': {
        draft.blockDates = action.payload.value;
        break;
      }

      case '@unityregistration/UNITY_COUNTIES': {
        draft.counties = action.payload.value;
        break;
      }

      case '@unityregistration/MUNICIPIOPRODUTOS': {
        draft.countiesProduts = action.payload.value;
        break;
      }


      case '@unityregistration/UNITY_QUOTAS': {
        draft.quotas = action.payload.value;
        break;
      }

      case '@unityregistration/UNITY_RESETVALUES': {
        draft.daysWeek = [];
        draft.blockDates = [];
        draft.counties = [];
        draft.quotas = [];
        break;
      }

      default:
    }
  });
}
